import {
  ReviewDiffCellDetail,
  ReviewDiffRowInfo,
} from "../services/if-definitions";

export type DiffValue = ReviewDiffCellDetail["before"] | undefined;

export type DiffSegment = {
  text: string;
  changed: boolean;
};

export const normalizeDiffValue = (value?: DiffValue): string => value ?? "";

export const getReviewDiffCell = (
  reviewDiffInfo?: ReviewDiffRowInfo,
  diffPath?: string,
): ReviewDiffCellDetail | undefined => {
  if (!reviewDiffInfo || !diffPath) return undefined;
  if (diffPath.startsWith("src.")) {
    return reviewDiffInfo.src?.cellDiffs?.[diffPath];
  }
  if (diffPath.startsWith("dst.")) {
    return reviewDiffInfo.dst?.cellDiffs?.[diffPath];
  }
  return undefined;
};

export const buildDiffSegments = (
  before = "",
  after = "",
): { before: DiffSegment[]; after: DiffSegment[] } => {
  let start = 0;
  while (
    start < before.length &&
    start < after.length &&
    before[start] === after[start]
  ) {
    start++;
  }

  let beforeEnd = before.length - 1;
  let afterEnd = after.length - 1;

  while (
    beforeEnd >= start &&
    afterEnd >= start &&
    before[beforeEnd] === after[afterEnd]
  ) {
    beforeEnd--;
    afterEnd--;
  }

  const beforeSegments: DiffSegment[] = [
    { text: before.slice(0, start), changed: false },
    { text: before.slice(start, beforeEnd + 1), changed: true },
    { text: before.slice(beforeEnd + 1), changed: false },
  ].filter((seg) => seg.text !== "");

  const afterSegments: DiffSegment[] = [
    { text: after.slice(0, start), changed: false },
    { text: after.slice(start, afterEnd + 1), changed: true },
    { text: after.slice(afterEnd + 1), changed: false },
  ].filter((seg) => seg.text !== "");

  return {
    before: beforeSegments,
    after: afterSegments,
  };
};
